import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

interface SelectOption {
  label: string;
  value: string | number;
}

interface SelectProps {
  options: (string | SelectOption)[]; // List of options to display
  value?: string | null;
  onChange: (value: string) => void;
  className?: string;
  defaultValue? : string;
  placeholder?: string;
  disabled? : boolean;
}

const ReusableSelect: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  className,
  defaultValue,
  placeholder,
  disabled,
}) => {

  // Normalize all options to { label, value } format
  const normalizedOptions: SelectOption[] = options.map((option, index) =>
    typeof option === "object"
      ? (option as SelectOption) // Keep existing object structure
      : { label: String(option), value: option ?? index } // Convert primitive values
  );

  return (
    <Select
      value={value}
      onChange={onChange}
      className={className}
      defaultValue={defaultValue}
      placeholder={placeholder}
      disabled={disabled}
    >
        {normalizedOptions.map(({ label, value }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  );
};

export default ReusableSelect;